import React, { useEffect, useState } from "react";

import { DatePicker } from "antd";
import Styles from "./input.module.css";
import Text from "components/text";
import dayjs from "dayjs";
import errorIcon from "assets/images/error-icon.svg";
import moment, { weekdays } from "moment";
import { useSelector } from "react-redux";
const InputComponent = ({
  defaultValue = "",
  id = "",
  className = "",
  inputClassName = "",
  inputIconContainerClass = "",
  number = false,
  style,
  type = "",
  label = "",
  required = false,
  placeholder = "",
  handleChange = (e) => {},
  handleBlur = () => {},
  value,
  onChange,
  errors = "",
  hasIcon = false,
  Icon = () => {},
  ischecked = false,
  textarea = false,
  isDate = false,
  havemargin = true,
  normalError = false,
  disabled = false,
  disabledDate = false,
  customDisabledDates = false,
  ...prop
}) => {
  const dateFormat = "MM-DD-YYYY";
  const [selectedDate, setSelectedDate] = useState(
    isDate && value ? dayjs(value, dateFormat) : null
  );

  const { projectDetails } = useSelector((state) => state.projectDetails);

  const WorkingDays = projectDetails.workingDays;
  const nonWorkingDays = projectDetails.nonWorkingDays;

  useEffect(() => {
    if (isDate && value) {
      const parsedDate = dayjs(value, dateFormat);
      // console.log(parsedDate, "parsedDate");
      setSelectedDate(parsedDate);
    } else {
      setSelectedDate(null);
    }
  }, [isDate, value]);

  const defaultPickerValue = selectedDate;

  const handleDateChange = (date, dateString) => {
    setSelectedDate(date);
    onChange(dateString);
  };

  const isDateDisabled = (date) => {
    // Handling Holidays
    const disabledDatesArray = [];
    Object.values(nonWorkingDays).forEach((holiday) => {
      var currDate = moment(holiday["startDate"], "MM/DD/YYYY").startOf("day");
      var lastDate = moment(holiday["finishDate"], "MM/DD/YYYY").startOf("day");
      disabledDatesArray.push(moment(currDate).format("YYYY-MM-DD"));
      while (currDate.add(1, "days").diff(lastDate) < 0) {
        disabledDatesArray.push(moment(currDate).format("YYYY-MM-DD"));
      }
      disabledDatesArray.push(moment(lastDate).format("YYYY-MM-DD"));
    });

    // Handling Weekends
    const disabledWorkingdays = Object.values(WorkingDays);
    const adjustingDayOffs = disabledWorkingdays.shift();
    disabledWorkingdays.push(adjustingDayOffs);
    const weeklyDayOffindexs = [];
    const dayofWeek = date.day();

    disabledWorkingdays.forEach((item, index) => {
      if (item === "0") {
        weeklyDayOffindexs.push(index);
      }
    });

    const formattedDate = date.format("YYYY-MM-DD");
    return (
      ((disabledDatesArray.includes(formattedDate) ||
        weeklyDayOffindexs.includes(dayofWeek)) &&
        customDisabledDates) ||
      (date && date > moment().endOf("day") && disabledDate)
    );
  };

  const handleNumberInput = (e) => {
    if (number) {
      // Allow only numbers, backspace, delete, tab, escape, enter, and decimal point
      const allowedKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "Escape",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
      ];

      if (allowedKeys.includes(e.key)) {
        return; // Allow these keys
      }

      // Allow decimal point only once
      if (e.key === "." && !e.target.value.includes(".")) {
        return;
      }

      // Block any non-numeric characters
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    }
  };
  return (
    <>
      {label && (
        <div className="d-flex align-items-start">
          <small className=" fw-bold" htmlFor={id}>
            {label}
          </small>
          {required && (
            <small htmlFor={id} className={`${Styles.star} mx-1 fw-bold`}>
              *
            </small>
          )}
        </div>
      )}

      {!textarea && isDate ? (
        <div
          className={`${Styles.dateContainer} ${className} d-flex justify-content-around align-items-center`}
        >
          <div className="mb-1">{Icon}</div>
          <DatePicker
            defaultValue={defaultPickerValue}
            format={dateFormat}
            onChange={handleDateChange}
            value={selectedDate}
            placeholder=""
            className="antPickerStyle"
            style={{
              border: "none",
              backgroundColor: "transparent",
              ...style,
            }}
            disabled={disabled}
            disabledDate={customDisabledDates ? isDateDisabled : null}
          />
        </div>
      ) : (
        <div
          className={` ${Styles.container} w-100 ${
            havemargin ? "mb-3" : ""
          }position-relative  ${className}`}
        >
          {textarea ? (
            <>
              {Icon}

              <textarea
                onChange={(e) => {
                  const newValue = e.target.value;
                  onChange(newValue);
                }}
                onBlur={() => {
                  handleBlur();
                }}
                placeholder={placeholder}
                type={type}
                value={value}
                className={`${Styles.input} ${Styles.textarea} ${inputClassName} `}
                style={{
                  ...style,
                  borderColor: errors ? "#e93c3c" : "#C8C8C8",
                }}
                {...prop}
              ></textarea>
            </>
          ) : (
            <>
              <input
                onChange={(e) => {
                  const newValue =
                    type === "checkbox" ? e.target.checked : e.target.value;
                  // For regular input, if number is true, filter out non-numeric characters
                  if (number) {
                    const numericValue = newValue.replace(/[^0-9.]/g, "");
                    // Ensure only one decimal point
                    const parts = numericValue.split(".");
                    const filteredValue =
                      parts.length > 2
                        ? parts[0] + "." + parts.slice(1).join("")
                        : numericValue;
                    onChange(filteredValue);
                  } else {
                    onChange(newValue);
                  }
                }}
                onBlur={() => {
                  handleBlur();
                }}
                id={id}
                defaultValue={defaultValue}
                placeholder={placeholder}
                type={type}
                {...(type === "checkbox"
                  ? { checked: Boolean(value) }
                  : { value })}
                disabled={disabled}
                className={`${Styles.input} ${inputClassName}`}
                style={{
                  ...style,
                  borderColor: errors ? "#e93c3c" : "#C8C8C8",
                }}
                {...prop}
              />
              {Icon}
            </>
          )}

          {errors && !normalError && (
            <div
              className={`d-flex align-items-center ${Styles.errorContainer}`}
            >
              <img
                src={errorIcon}
                alt="errorIcon"
                className={`${Styles.errorIcon}`}
              />
              <Text className={`${Styles.error_msg}`}>
                {errors?.message || errors}
              </Text>
            </div>
          )}
        </div>
      )}

      {errors && normalError && (
        <Text className={`${Styles.error_msg} mt-1`}>
          {errors?.message || errors}
        </Text>
      )}
    </>
  );
};

export default InputComponent;
